import axios from 'axios';
import store from '../store'
import verifyAuth from '../services/utilities'

class TournamentRepository {

    constructor() {
        this.basePath = store.state.backend;
    }

    getAllTournaments() {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getPublicTournaments() {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/public`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getAllTournamentParticipants(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournament-participants/all?tournamentId=${tournamentId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    // SFB-1309: admin-only CSV rows of a community's competitions; `ids` = what the UI shows.
    exportClubTournaments(clubId, ids) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournaments/club/${clubId}/export`, ids, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    // SFB-1309: same, for broker staff (scoped server-side by their COMPETITION_LIST_* permission).
    // `request` = { ids, championshipIds }: the competitions and championships the UI shows.
    exportBrokerTournaments(request) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/brokers/tournament/admin/export`, request, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentsByClubId(clubId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/club?clubId=${clubId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    findParticipantByTournament(tournamentId, userId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournament-participants?tournamentId=${tournamentId}&userId=${userId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    enrollParticipant(tournamentParticipant) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournament-participants`, tournamentParticipant, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentOverview(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/overview/${tournamentId}`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentOverviewAdmin(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/${tournamentId}/overview/admin`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentOverviewOpen(tournamentId, identifier, page = 0, size = 5000) {
        // Server-side pagination support
        // Default size=5000 to fetch all participants for most tournaments
        // Table.vue handles client-side pagination for display (10 per page)
        // For tournaments with >5000 participants, increase this value or implement true server-side pagination
        let url = identifier
            ? `${this.basePath}/ext/tournaments/overview-open/${tournamentId}/${identifier}?page=${page}&size=${size}`
            : `${this.basePath}/ext/tournaments/overview-open/${tournamentId}?page=${page}&size=${size}`;
        let response = axios.get(url);
        response = verifyAuth(response)
        return response;
    }

    createFullTournament(fullTournament) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournaments/create-full`, fullTournament, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    createFullTournamentSettings(fullTournamentSettings) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournamentSettings/tournaments/create-full/tournamentSettings`, fullTournamentSettings, { headers: headers });
        response = verifyAuth(response)
        return response;
    }


    editFullTournament(tournamentEditData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournaments/edit-full`, tournamentEditData, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    editFullTournamentSettings(tournamentEditData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournamentSettings/tournaments/edit-full-tournament`, tournamentEditData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    listSkinThemesForBroker() {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/competition-skin-themes/for-broker`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    listSkinCharacters(themeId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/competition-skin-themes/${themeId}/characters`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    editTournamentBasics(basicsData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-basics`, basicsData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    editTournamentPrizes(prizesData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-prizes`, prizesData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    updateTournamentImage(data) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournaments/tournament-image/${data.tournamentId}`, data.formData, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    changeParticipantStatus(participantId, newStatus, disqualificationReason) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        const body = { participantId, newStatus };
        if (newStatus === 'DISQUALIFIED' && disqualificationReason != null && String(disqualificationReason).trim()) {
            body.disqualificationReason = String(disqualificationReason).trim();
        }
        let response = axios.put(`${this.basePath}/ext/tournament-participants/status`, body, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getTournamentsByUser(userId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/${userId}/tournaments`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    sendTournamentRequest(request) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournaments/request-creation`, request, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    updateParticipantBrokerAccount(participantId, brokerAccountId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournament-participants/update-assigned-account?participantId=${participantId}&brokerAccountId=${brokerAccountId}`, null, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentRules(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/rules/${tournamentId}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getClubBrokers(clubId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournamentsettings/${clubId}/brokers`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getServerDetails(brokerId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/meta-trader-server-details/server-group/${brokerId}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    // New methods for tournament archiving
    getArchivedTournaments() {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournamentSettings/archived`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentsByVisibility(visibilityType) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournamentSettings/visibility-types?visibility=${visibilityType}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    archiveTournament(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournamentSettings/${tournamentId}/visibility/ARCHIVED`, null, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    unarchiveTournament(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournamentSettings/${tournamentId}/visibility/PRIVATE`, null, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    // Creates an editable copy of the tournament's configuration in PLANNING state
    // (no participants/results carried over). `overrides` is optional: { name, startTime, endTime, tournamentVisibility }.
    duplicateTournament(tournamentId, overrides = null) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/ext/tournaments/${tournamentId}/duplicate`, overrides, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getRankingRules(rankingType) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournamentSetting/${rankingType}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    registerPublicTournament(payload) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/process-woocommerce`, payload, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    // Public self-registration for Exness API tournaments: the participant supplies
    // their own Exness account id + public API key/secret. Public endpoint, no auth.
    registerExnessTournament(payload) {
        return axios.post(`${this.basePath}/ext/tournaments/register-exness`, payload);
    }

    // Hard-removes a participant (SFB-1205). Backend only allows it before the
    // competition starts (409 otherwise) and requires competition-admin rights.
    removeTournamentParticipant(tournamentId, participantId, reason) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/brokers/tournament/admin/${tournamentId}/participants/remove`,
            { participantId: participantId, reason: reason || null }, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    updateTournamentState(tournamentId, state) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/ext/tournamentSettings/${tournamentId}/state/${state}`, {}, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    // New wizard endpoints
    getWizardConfiguration(clubId) {
        //eslint-disable-next-line no-console
        console.log('Getting wizard configuration for clubId:', clubId);
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        //eslint-disable-next-line no-console
        console.log('Getting wizard configuration with headers:', headers);
        let response = axios.get(`${this.basePath}/ext/tournaments/wizard?clubId=${clubId}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getWizardRankings(clubId, platform, platformGroupId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken']};
        let url = `${this.basePath}/ext/tournaments/wizard/ranking?clubId=${clubId}&platform=${platform}`;
        if (platformGroupId !== null && platformGroupId !== undefined) {
            url += `&platformGroupId=${platformGroupId}`;
        }
        let response = axios.get(url, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    /**
     * Competition presets (SFB-1289) — templates the wizard offers as its first
     * step. Served by brokerAdmin/rest/BrokerAdminTournamentResource, so it
     * needs a partner-staff account with COMPETITION_CREATE (see TD-022).
     */
    getCompetitionPresets() {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/presets`, { headers: headers });
        response = verifyAuth(response)
        return response;
    }

    getWizardRules(clubId, platform, platformGroupId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let url = `${this.basePath}/ext/tournaments/wizard/rules?clubId=${clubId}&platform=${platform}`;
        if (platformGroupId !== null && platformGroupId !== undefined) {
            url += `&platformGroupId=${platformGroupId}`;
        }
        let response = axios.get(url, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getParticipantAnalyticsMini(tournamentId, participantId, tournametStartDate, tournametEndDate ) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        const payload = {
            tournamentId: tournamentId,
            participantId: participantId,
            fromDate: tournametStartDate,
            toDate: tournametEndDate
        };
        let response = axios.post(`${this.basePath}/ext/tournaments/participants/analytics/mini?page=0&size=1`, payload, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentPrizePool(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/${tournamentId}/prize-pool`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentBrackets(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/tournaments/master/brackets/by-tournament/${tournamentId}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    editTournamentRules(rulesData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-rules`, rulesData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    editTournamentBranding(brandingData) {
        let headers = { 
            'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken']
        };
        // Don't set Content-Type for FormData - axios will set it automatically with the correct boundary
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-branding`, brandingData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    editTournamentBrandingBulk(tournamentId, brandingData) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        // OJO: no setear Content-Type para FormData
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/tournaments/${tournamentId}/branding-bulk`, brandingData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    getTournamentBrandingImage(imageKey) {
        let headers = { 
            'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken']
        };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/branding-image/${imageKey}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    getTournamentBranding(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/${tournamentId}/branding`,{ headers });
        response = verifyAuth(response);
        return response;
    }
    getAdminInfo(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/${tournamentId}/settings/admin-info`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    editTournamentRanking(rankingData) {
        let headers = { 
            'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken']
        };
        let response = axios.put(`${this.basePath}/brokers/tournament/admin/edit-ranking`, rankingData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    sendAccountEmail(tournamentId, payload) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        const body = {
            participantId: payload.participantId,
            type: payload.type,
            start: 0,
            batch: 1,
        };
        let response = axios.post(
            `${this.basePath}/ext/tournament-participants/emails/${tournamentId}/resends`,
            body,
            { headers: headers }
        );
        response = verifyAuth(response);
        return response;
    }

    sendTournamentParticipantsEmail(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.post(`${this.basePath}/brokers/tournament/admin/report/${tournamentId}/participants/send-email`, {}, { headers: headers });
        response = verifyAuth(response);
        return response;
    }
    getTournamentFinalStats(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/report/${tournamentId}/final-stats`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    // Split endpoints: info (no participants) + paginated participants

    getTournamentAdminInfo(tournamentId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/ext/tournaments/${tournamentId}/admin/info`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentAdminParticipants(tournamentId, page = 0, size = 10, search = '') {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let url = `${this.basePath}/ext/tournaments/${tournamentId}/admin/participants?page=${page}&size=${size}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        let response = axios.get(url, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getTournamentPublicInfo(externalId) {
        let url = `${this.basePath}/ext/tournaments/overview-open/${externalId}/info`;
        let response = axios.get(url);
        response = verifyAuth(response);
        return response;
    }

    // Platforms/servers a tournament is open to (SFB-1012 cross-server
    // registration). Public endpoint; >1 scope means the registration form
    // must let the user pick their server and send its scopeKey.
    getTournamentScopes(externalId) {
        return axios.get(`${this.basePath}/ext/tournaments/overview-open/${externalId}/scopes`);
    }

    getTournamentPublicParticipants(externalId, page = 0, size = 10, search = '') {
        let url = `${this.basePath}/ext/tournaments/overview-open/${externalId}/participants?page=${page}&size=${size}`;
        if (search) {
            url += `&search=${encodeURIComponent(search)}`;
        }
        let response = axios.get(url);
        response = verifyAuth(response);
        return response;
    }

    // SFB-1336: broker CSV import of participants without e-mail (account + optional names).

    getParticipantImportTemplate() {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/participants/import/template`, { headers: headers, responseType: 'text' });
        response = verifyAuth(response);
        return response;
    }

    // 202 { importId, status } when queued; 400 { message, errors[] } when the whole file is rejected.
    // No Content-Type here: axios adds multipart/form-data with its boundary (text/csv gets a 415).
    importParticipantsCsv(tournamentId, file) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        const formData = new FormData();
        formData.append('file', file);
        let response = axios.post(`${this.basePath}/brokers/tournament/admin/${tournamentId}/participants/import`, formData, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    getParticipantImport(tournamentId, importId) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/${tournamentId}/participants/imports/${importId}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

    // Spring Page of imports without `rows`, newest first.
    getParticipantImports(tournamentId, page = 0, size = 10) {
        let headers = { 'Authorization': store.state.token || 'Bearer ' + store.getters['broker/authToken'] };
        let response = axios.get(`${this.basePath}/brokers/tournament/admin/${tournamentId}/participants/imports?page=${page}&size=${size}`, { headers: headers });
        response = verifyAuth(response);
        return response;
    }

}

export default new TournamentRepository();
